/**
 * Modern Data Portal Button Component
 * @param {*} children
 * @param {string} className
 * @param {*} variant - primary(default) | outline | secondary | danger | success | warning | info
 * @param {function} onClick
 * @param {string} font
 * @param {boolean} disabled
 * @param {object} style
 * @returns 
 */
const Button = ({
    children = <></>,
    className = '',
    variant = 'primary',
    onClick = () => { },
    font = "fw-semibold",
    disabled = false,
    style = {},
    ...rest
}) => {

    const variants = {
        custom_primary: 'btn-primary',
        primary: 'btn-primary',
        outline: 'btn-outline',
        secondary: 'btn-secondary',
        danger: 'btn-danger',
        success: 'btn-success',
        warning: 'btn-warning',
        info: 'btn-info',
        light: 'btn-light',
        dark: 'btn-dark',
    };
    const current_variant = variants[variant] ?? 'btn-primary';

    return (
        <button
            className={`btn ${current_variant} ${font} ${className}`}
            onClick={(e) => onClick(e)}
            disabled={disabled}
            style={{
                borderRadius: '8px',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                ...style,
            }}
            {...rest}
        >
            {children}
        </button>
    );
};

export default Button;